/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cancel-icon[_ngcontent-%COMP%]{font-size:15px;margin-top:5px}"];
export { styles as styles };
